import React, { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { Dialog, DialogContent, DialogTitle } from '../../../components/base/Dialog/Dialog';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import { loadApplicationHistory } from '../actions';
import { getPaginationOpts, responseLogWithNotification, useUpdatePeriod } from '../../../utils/utils';
import { getApplicationData } from '../reducer';
import { dateTimeFormatter, subjectFormatter, userPositionFormatter } from '../../../utils/formatters';
import Pagination from '../../../components/base/Pagination/Pagination';
import { APPLICATION_MODULE } from '../../../configs/moduleNames';
import { getSystemData } from '../../System/reducer';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function ApplicationHistory({ close = () => {}, currentApplication }) {
  const { applicationHistory = [], loadingApplicationHistory = false, applicationHistoryMeta } = useSelector(getApplicationData);
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[APPLICATION_MODULE].applicationHistoryMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { subject_id: currentApplication.id },
    };
    const p1 = dispatch(loadApplicationHistory(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const columns = [
    {
      dataField: 'causer',
      text: 'Пользователь',
      headerClassName: 'user-column',
      formatter: userPositionFormatter,
      disableSort: true,
    },
    {
      dataField: 'created_at',
      text: 'Дата и время',
      headerClassName: 'date-time-column',
      disableSort: true,
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'context',
      text: 'Субъект',
      headerClassName: 'module-column',
      disableSort: true,
      formatter: (_, item) => subjectFormatter(item),
    },
    {
      dataField: 'description',
      text: 'Изменения в объекте',
      headerClassName: 'changes-to-object-column',
      disableSort: true,
    },
  ];

  return (
    <Dialog
      className="application-history"
      onClose={close}
      open
    >
      <DialogTitle header={`История изменений в обращении № ${currentApplication.mais_egu_id || 'Без номера'}`} title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-history-content custom-scroll-theme">
        <TimerLoader loading={loadingApplicationHistory} />
        <div className="grid-wrapper">
          <Grid data={applicationHistory} columns={columns} name="profile-list" />
          <div className="null-block" />
          <Pagination meta={applicationHistoryMeta} list={applicationHistory} handleChangeMeta={loadData} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
